<template>
  <div class="toggle-group">
    <span v-if="title">{{ title }}</span>
    <Toggle
      v-for="item in options"
      :key="item.label"
      small
      round
      v-model="item.value"
      :beforeLabel="item.label"
      @change="change"
    />
  </div>
</template>

<script>
import { Toggle } from "@international-energy-agency/vue-ui";
export default {
  components: {
    Toggle,
  },
  data() {
    return {
      value: false,
    };
  },
  props: {
    options: {
      type: Array,
    },
    small: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: false,
    },
  },
  methods: {
    change(value, type) {
      this.$emit("change");
    },
  },
};
</script>

<style>
.map-control__inner .a-input.a-input--toggle {
  padding: 0 !important;
}
</style>
